import { Tooltip } from 'antd';

import { Icon } from '@/shared/ui/Icon';

import { ASSET_URI_TOOLTIP_ITEMS } from '@/features/connectors/lib/assetUriTooltip';

import styles from './AssetUriTooltip.module.css';

type AssetUriTooltipProps = {
  iconClassName?: string;
};

const TOOLTIP_CONTENT = (
  <div className={styles.tooltipContent}>
    {ASSET_URI_TOOLTIP_ITEMS.map((item) => (
      <div className={styles.tooltipItem} key={item.title}>
        <p className={styles.tooltipTitle}>{item.title}</p>
        <p className={styles.tooltipDescription}>{item.content}</p>
      </div>
    ))}
  </div>
);

export const AssetUriTooltip = ({ iconClassName }: AssetUriTooltipProps) => (
  <Tooltip title={TOOLTIP_CONTENT} placement="bottomLeft" arrow={false} classNames={{ root: styles.tooltip }}>
    <span className={iconClassName}>
      <Icon name="tooltip" size={16} />
    </span>
  </Tooltip>
);
